// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResultTile_root__1a7z4"};